import { showErrorToast } from "src/lib/utils";
import { Navigate } from "react-router-dom";
import useHasPermissions from "./useHasPermissions";

const withPermissionWrapper = (WrappedComponent, permission) => {
	return function EnhancedComponent(props) {
		const hasPermission = useHasPermissions(permission);

		if (!hasPermission) {
			showErrorToast("You don't have permissions for this action");
			return <Navigate to={{ pathname: "/" }} />;
		}

		return <WrappedComponent {...props} />;
	};
};

export default withPermissionWrapper;
